import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Fade } from "react-awesome-reveal";
import { LinkContext } from "../../LinkProvider";

import MiniCard from "./MiniCard";
import SliderLine from "./SliderLine";

const CARDS = [
  { titleKey: "proof.card2.title", textKey: "proof.card2.text" },
  { titleKey: "proof.card1.title", textKey: "proof.card1.text" },
  { titleKey: "proof.card4.title", textKey: "proof.card4.text" },
  { titleKey: "proof.card3.title", textKey: "proof.card3.text" },
];

function ProofOfEdge() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);
  const swiperRef = useRef(null);
  const [current, setCurrent] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="flex flex-col sm:flex-row sm:items-start gap-[25px] sm:gap-[40px] lg:gap-[62px]">
          {/* Слева: заголовок + кнопка */}
          <Fade triggerOnce direction="left" duration={700}>
          <div className="sm:flex-1 flex flex-col items-center sm:items-start">
            <h2 className="font-42-28">{t("proof.title")}</h2>
            <a
              href={link}
              className="hidden sm:inline-flex mt-[40px] items-center justify-center px-[42px] py-[18px] rounded-[40px] border border-white font-['Inter'] font-bold text-[16px] text-white capitalize backdrop-blur-[15px] hover:opacity-90 hover:scale-[1.04] transition-all"
              style={{
                backgroundImage:
                  "linear-gradient(-84deg, rgba(14,28,54,0.8) 6%, rgba(3,65,180,0.8) 66%)",
              }}
            >
              {t("proof.cta")}
            </a>
          </div>
          </Fade>

          {/* Справа: 2x2 карточки (desktop) */}
          <div className="hidden sm:grid grid-cols-2 gap-[20px] sm:w-[62%] lg:w-[718px] shrink-0">
            {CARDS.map((card, i) => (
              <MiniCard key={i} title={t(card.titleKey)} text={t(card.textKey)} />
            ))}
          </div>

          {/* Мобильный слайдер */}
          <div className="sm:hidden w-full">
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setCurrent(swiper.realIndex)}
              spaceBetween={16}
              slidesPerView={1}
              grabCursor
            >
              {CARDS.map((card, i) => (
                <SwiperSlide key={i}>
                  <MiniCard title={t(card.titleKey)} text={t(card.textKey)} />
                </SwiperSlide>
              ))}
            </Swiper>
            <SliderLine
              current={current}
              total={CARDS.length}
              onPrev={() => swiperRef.current?.slidePrev()}
              onNext={() => swiperRef.current?.slideNext()}
            />
            <a
              href={link}
              className="mt-[30px] mx-auto flex w-fit items-center justify-center px-[42px] py-[14px] rounded-[40px] border border-white font-['Inter'] font-bold text-[14px] text-white capitalize backdrop-blur-[15px]"
              style={{
                backgroundImage:
                  "linear-gradient(-84deg, rgba(14,28,54,0.8) 6%, rgba(3,65,180,0.8) 66%)",
              }}
            >
              {t("proof.cta")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProofOfEdge;
